import { render } from "./AdminHome.vue?vue&type=template&id=0bd58502&scoped=true&ts=true"
import script from "./AdminHome.vue?vue&type=script&lang=ts"
export * from "./AdminHome.vue?vue&type=script&lang=ts"

import "./AdminHome.vue?vue&type=style&index=0&id=0bd58502&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd58502"]])

export default __exports__